import PropTypes from 'prop-types'
import React, { useState } from "react"
import { Modal, ModalBody } from "reactstrap"

const SaveContinueModal = ({ show, onSaveClick, onCloseClick, loading }) => {
  return (
    <Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">{"Are you sure? Your progress on the current question will be lost. Answer all the questions to save your progress."}</p>

          <div className="hstack gap-2 justify-content-center mb-0">
          <button type="button" className="btn btn-danger" onClick={() => {
                  onSaveClick()
                }}>Yes
          </button>

          <button type="button" className="btn btn-secondary" onClick={onCloseClick}>No</button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

SaveContinueModal.propTypes = {
  onCloseClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  show: PropTypes.any
}

export default SaveContinueModal
